import { render, staticRenderFns } from "./KSelectRequirementQuestion.vue?vue&type=template&id=50f5cb78&"
import script from "./KSelectRequirementQuestion.vue?vue&type=script&lang=js&"
export * from "./KSelectRequirementQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports